import type { DefaultQueryError } from '@ahm/api-wrappers-core';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { apiRoutes } from './api-routes';
import { webviewHttpClient } from '@/app/[locale]/(order)/components/auth/webview-http-client';

export interface UserLocation {
  lat: number;
  lng: number;
  address: string;
  place_id: string;
  save_at: number;
}

export interface GetUserLocationsResponse {
  address_histories: UserLocation[];
}

export const getUserLocationsFn = async (
  token?: string
): Promise<GetUserLocationsResponse> => {
  const headers: Record<string, string> = {};
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await webviewHttpClient.get<GetUserLocationsResponse>(
    apiRoutes.ahafood.store.add_new_address,
    {
      headers,
    }
  );

  return response?.data;
};

export const useGetUserLocations = (
  token?: string,
  opts?: Omit<
    UseQueryOptions<
      GetUserLocationsResponse,
      DefaultQueryError,
      GetUserLocationsResponse,
      string[]
    >,
    'queryKey' | 'queryFn'
  >
) =>
  useQuery<
    GetUserLocationsResponse,
    DefaultQueryError,
    GetUserLocationsResponse,
    string[]
  >({
    queryKey: ['user-locations'],
    queryFn: () => getUserLocationsFn(token),
    enabled: !!token,
    ...opts,
  });
